module.exports = __webpack_public_path__ + "static/media/UHS_Logo_AdminPortal.3315c81b.png";